window.addEventListener("load", (event) => {
    let previousIndex = null;  // Track the previous index to determine the direction
    let isAnimating = false; // Lock to prevent multiple simultaneous animations
    const progressBar = document.querySelector('.case-study-slider-progress-bar');
    const autoplayDelay = 6000; // 6 seconds

    const startProgressBar = (delay = autoplayDelay) => {
        // Reset the progress bar immediately
        progressBar.style.transition = 'none';
        progressBar.style.width = '0%';

        // Start the progress bar filling again after a short delay
        setTimeout(() => {
            progressBar.style.transition = `width ${delay}ms linear`;
            progressBar.style.width = '100%';
        }, 10); // A small delay to ensure the reset has taken effect
    };

    const swiper = new Swiper(".case-study-slider", {
        loop: true,
        grabCursor: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        autoplay: {
            delay: autoplayDelay,
            disableOnInteraction: false
        },
        on: {
            init: function () {
                // Start the progress bar on initialization
                startProgressBar();
            },

            slideChangeTransitionStart: function () {
                // Prevent triggering new animations if one is already in progress
                if (isAnimating) return;

                const currentIndex = this.realIndex;
                const targetIndex = this.activeIndex % this.slides.length;

                if (currentIndex === targetIndex) {
                    return;
                }

                // Hide all slides immediately except the active one
                this.slides.forEach((slide, index) => {
                    if (index !== this.activeIndex) {
                        slide.style.opacity = '0';
                    }
                });
            },

            slideChange: function () {
                // Prevent triggering new animations if one is already in progress
                if (isAnimating || this.realIndex == previousIndex) return;

                const activeSlide = this.slides[this.realIndex + 1];
                const newBackground = activeSlide.getAttribute("data-background");

                this.slides.forEach(slide => {
                    slide.style.opacity = '0';
                    const content = slide.querySelector('.swiper-slide-content');
                    if (content) {
                        content.style.opacity = '0';
                    }
                });

                if (newBackground) {
                    const currentBackgroundImage = document.querySelector('.case-study-background-img');
                    const isGoingForward = this.realIndex > previousIndex || (this.realIndex === 0 && previousIndex === this.slides.length - 1);
                    previousIndex = this.realIndex;  // Update the previous index

                    // Lock animation to prevent new ones from starting
                    isAnimating = true;

                    // Create a new image element for the sliding effect
                    const newBackgroundImage = document.createElement('img');
                    newBackgroundImage.src = newBackground;
                    newBackgroundImage.alt = activeSlide.querySelector('.swiper-slide-content h3')?.innerText || '';
                    newBackgroundImage.classList.add('case-study-background-img', 'position-absolute', 'w-100', 'h-100', 'top-0', 'left-0', 'object-fit-cover');

                    // Set the initial position based on the direction
                    newBackgroundImage.style.transform = isGoingForward ? 'translateX(100%)' : 'translateX(-100%)';
                    newBackgroundImage.style.transition = 'transform 1s ease-in-out';

                    // Insert the new background image
                    currentBackgroundImage.parentNode.insertBefore(newBackgroundImage, currentBackgroundImage);

                    // Use a short delay to allow the browser to render the new image before applying the transform
                    setTimeout(() => {
                        currentBackgroundImage.style.transform = isGoingForward ? 'translateX(-100%)' : 'translateX(100%)';
                        newBackgroundImage.style.transform = 'translateX(0)';
                    }, 20); // 20ms delay is typically enough to ensure the transition is rendered

                    // After the animation ends, remove the old image and reset the transform of the new image
                    newBackgroundImage.addEventListener('transitionend', () => {
                        // Remove the old image from the DOM
                        currentBackgroundImage.remove();

                        // Reset styles of the new image to ensure it has no inline styles
                        newBackgroundImage.style.transform = '';
                        newBackgroundImage.style.transition = '';

                        // Unlock animation to allow new ones to start
                        isAnimating = false;
                    });
                }
            },

            slideChangeTransitionEnd: function () {
                const activeSlide = this.slides[this.activeIndex];

                // Ensure that only the active slide is fully visible
                this.slides.forEach((slide, index) => {
                    if (index === this.activeIndex) {
                        slide.style.opacity = '1';
                    } else {
                        slide.style.opacity = '0';
                    }
                });

                const activeContent = activeSlide.querySelector('.swiper-slide-content');
                if (activeContent) {
                    setTimeout(() => {
                        activeContent.style.opacity = '1';
                    }, 500);
                }
                startProgressBar();
            }
        }
    });
});